import { render, staticRenderFns } from "./MobileOrderCard.vue?vue&type=template&id=3412bdfa"
import script from "./MobileOrderCard.vue?vue&type=script&lang=js"
export * from "./MobileOrderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports